@if (selectedIds.length >= 1) {
    <div class="flex justify-between bg-cool-grey-5 px-20 py-4">
        <div>
            <div class="text-white text-lg">{{ selectedIds.length }} Item(s) Selected</div>
            <div class="text-cool-grey-3 text-sm">Max 3 items can be selected</div>
        </div>

        <div class="flex gap-x-3">
            <button
                type="button"
                class="px-8 py-3 rounded-lg border border-solid border-cool-grey bg-[#EFEFEF99] text-cool-grey-5"
                translate
                (click)="onCancel()">
                Cancel
            </button>

            <button type="button" class="px-8 py-3 rounded-lg bg-primary text-white" translate (click)="onCompare()">
                <span>Compare</span>
                <i class="las la-arrow-right ml-2"></i>
            </button>
        </div>
    </div>
}
